
'use client';

import * as React from 'react';
import { useTheme } from '@/context/theme-context';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Paintbrush } from 'lucide-react';

const themes = [
  { name: 'Default', id: 'default', colors: ['#8FBC8F', '#F5F5DC', '#BDB76B'] },
  { name: 'Desert Oasis', id: 'desert-oasis', colors: ['#4682B4', '#F0E68C', '#CD853F'] },
  { name: 'Midnight Mosque', id: 'midnight-mosque', colors: ['#FFD700', '#191970', '#4169E1'] },
  { name: 'Rose Gold', id: 'rose-gold', colors: ['#B76E79', '#F8F0E3', '#8FBC8F'] },
];

export default function ThemeSelector() {
  const { theme, setTheme } = useTheme();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
            <Paintbrush className="w-5 h-5 text-primary" />
            Premium Themes
        </CardTitle>
        <CardDescription>
          As a premium member, you can customize the look and feel of your app. Select a theme below.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {themes.map((t) => (
            <div key={t.id} onClick={() => setTheme(t.id)} className="cursor-pointer">
              <div className="flex items-center space-x-2">
                <div className="flex -space-x-2">
                  {t.colors.map((color, index) => (
                    <div
                      key={index}
                      className="w-6 h-6 rounded-full border-2 border-background"
                      style={{ backgroundColor: color }}
                    />
                  ))}
                </div>
                <h3 className="font-semibold text-sm">{t.name}</h3>
                {theme === t.id && <Check className="w-5 h-5 text-primary" />}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
